
export default {
    name: 'SiteAlert',
    props: {
        /**
         * Alert message body
         */
        text: {
            type: String,
            required: true,
        },
        /**
         * Primary link Object (Nuxt), { text: 'link name', to: { name: 'somewhere' } }
         */
        link: {
            type: Object,
            default: null,
        },
        /**
         * Callback Object to execute a function, { text: 'callback name', func: func() }
         */
        callback: {
            type: Object,
            default: null,
        },
        /**
         * Should the alert be dismissible?
         */
        dismissible: {
            type: Boolean,
            default: true,
        },
        /**
         * Alert style type
         */
        type: {
            type: String,
            default: 'basic',
            validator(value) {
                return ['basic', 'info'].indexOf(value) !== -1;
            },
        },
    },
    data() {
        return {
            display: true,
        };
    },
};
